// API Configuration
// Centralized configuration for API endpoints and base URLs

// Use live API URL directly
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://astroindia.netsolutionindia.com';


export const API_CONFIG = {
  // Base URL for API requests (live URL)
  API_BASE_URL: API_BASE_URL,
  
  // Base URL for image assets
  IMAGE_BASE_URL: process.env.REACT_APP_IMAGE_BASE_URL || 'https://customsbuckets.s3.us-west-2.amazonaws.com/assets/consultants3assets/original',
  
  // Google Gemini API Configuration
  GEMINI_API_KEY: process.env.REACT_APP_GEMINI_API_KEY || 'AIzaSyBFEbCfNx6R9CcyXwiVFV_CwwwOQve5mkw',
  GEMINI_MODEL: process.env.REACT_APP_GEMINI_MODEL || 'gemini-2.0-flash',
  
  // API endpoints
  ENDPOINTS: {
    GET_ASTROLOGER_LIST: '/api/get-astrologer-list',
    GET_ASTROLOGER_DATA: '/api/get-astrologer-data',
    SEND_EMAIL_OTP: '/api/send-email-otp',
    VERIFY_EMAIL_OTP: '/api/email-verify',
    SEND_PHONE_OTP: '/api/send-otp',
    VERIFY_PHONE_OTP: '/api/verify-otp',
    UPLOAD_IMAGE: '/api/upload-image',
    ASTROLOGER_REGISTRATION: '/api/astrologer-registration',
    GENERATE_BIO: '/api/generate-bio'
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint, params = {}) => {
  // Use live URL directly
  const baseUrl = API_CONFIG.API_BASE_URL || 'https://astroindia.netsolutionindia.com';
  let fullUrl = `${baseUrl}${endpoint}`;
  
  // Add query parameters if any
  if (Object.keys(params).length > 0) {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      searchParams.append(key, params[key]);
    });
    fullUrl += `?${searchParams.toString()}`;
  }
  
  return fullUrl;
};

// Helper function to get full image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  return `${API_CONFIG.IMAGE_BASE_URL}/${imagePath}`;
};
